var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 15.3734V15.2215C15.75 14.7658 15.2658 14.1582 14.7815 13.8544L13.1674 12.943C12.6832 12.6392 12.0375 12.7911 11.5533 12.943L10.7462 13.3987C8.48644 12.3354 7.03373 10.2089 6.87232 7.77848L7.67938 7.32278C8.16362 7.01899 8.48644 6.41139 8.48644 5.9557V4.13291C8.48644 3.67722 8.16362 3.06962 7.67938 2.76582L7.35656 2.61392C7.03373 2.46203 6.22667 2.46203 5.74243 2.61392L4.61255 3.37342C4.45113 3.52532 4.12831 3.98101 4.12831 3.98101C3.32125 6.86709 3.80549 10.057 5.58102 12.4873C7.19514 15.0696 9.93916 16.8924 13.006 17.5C13.006 17.5 13.4902 17.5 13.8131 17.3481L15.1044 16.7405C15.4272 16.4367 15.75 15.8291 15.75 15.3734Z",
    fill: "#070707"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.6ed3a0303984dbc0a20432f5a65fb930.svg";
export { ForwardRef as ReactComponent };